import Partner from "../../types/Partner";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchAllPartners } from "../actions/map/mapActions/mapApiActions";

export interface MapInitialState {
  partners: Partner[];
  error: any;
  isLoading: boolean;
  singleMarkerResult?: Partner;
  queryResults?: Partner[];
  bounds?: google.maps.LatLngBounds;
  query: string;
}

const MAP_INITIAL_STATE = {
  partners: [],
  isLoading: false,
  error: "",
  query: ""
} as MapInitialState;

const mapSlice = createSlice({
  name: "map",
  initialState: MAP_INITIAL_STATE,
  reducers: {
    setLoadingStatus(state, action: PayloadAction<{ isLoading: boolean }>) {
      state.isLoading = action.payload.isLoading;
    },
    setError(state, action: PayloadAction<{ error: any }>) {
      state.error = action.payload.error;
    },
    setQueryToStore(state, action: PayloadAction<{ query: string }>) {
      state.query = action.payload.query;
    },
    sendBoundsToStore(
      state,
      action: PayloadAction<{ bounds: google.maps.LatLngBounds }>
    ) {
      state.bounds = action.payload.bounds;
    },
    setQueryResults(state, action: PayloadAction<{ queryResults: Partner[] }>) {
      state.queryResults = action.payload.queryResults;
    },
    setSingleMarkerResult(
      state,
      action: PayloadAction<{ singleMarkerResult: Partner }>
    ) {
      state.singleMarkerResult = action.payload.singleMarkerResult;
    }
  },
  extraReducers: fetchPartners => {
    fetchPartners.addCase(fetchAllPartners.pending, state => {
      state.isLoading = true;
    });
    fetchPartners.addCase(fetchAllPartners.fulfilled, (state, action) => {
      state.isLoading = false;
      state.partners = action.payload.partners;
    });
    fetchPartners.addCase(fetchAllPartners.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  }
});

export const {
  setSingleMarkerResult,
  setQueryResults,
  sendBoundsToStore,
  setQueryToStore,
  setError,
  setLoadingStatus
} = mapSlice.actions;

export default mapSlice.reducer;
